import React from 'react';
import { Link } from 'react-router-dom';
import TopNavbar from './../home/TopNavbar';

const styles = `
  .cs-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
    text-align: center;
    padding: 20px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    margin-top:70px;
  }

  .cs-card {
    background: white;
    padding: 40px;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    max-width: 500px;
    width: 100%;
    border-top: 5px solid #004d40;
  }

  .cs-icon {
    font-size: 4rem;
    margin-bottom: 20px;
    display: inline-block;
    animation: float 3s ease-in-out infinite;
  }

  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-15px); }
    100% { transform: translateY(0px); }
  }

  .cs-title {
    color: #004d40;
    font-size: 2.5rem;
    margin-bottom: 10px;
  }

  .cs-text {
    color: #555;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 30px;
  }

  .cs-loader {
    width: 100%;
    height: 8px;
    background: #e8f5e9;
    border-radius: 10px;
    margin-bottom: 30px;
    overflow: hidden;
    position: relative;
  }

  .cs-progress {
    width: 60%;
    height: 100%;
    background: #004d40;
    border-radius: 10px;
    animation: loading 2s infinite ease-in-out;
  }

  @keyframes loading {
    0% { width: 10%; }
    50% { width: 80%; }
    100% { width: 10%; }
  }

  .home-btn {
    display: inline-block;
    background-color: #004d40;
    color: white;
    padding: 12px 25px;
    border-radius: 30px;
    text-decoration: none;
    font-weight: bold;
    transition: all 0.3s ease;
  }

  .home-btn:hover {
    background-color: #00695c;
    transform: scale(1.05);
    box-shadow: 0 5px 15px rgba(0, 77, 64, 0.3);
  }
`;

function ComingSoon() {
  return (
    <div>
      <style>{styles}</style>
      <TopNavbar name="Coming Soon" />
      
      <div className="cs-container">
        <div className="cs-card">
          <div className="cs-icon">🚀</div>
          <h1 className="cs-title">Coming Soon</h1>
          <p className="cs-text">
            We are working hard to bring you the best <strong>NEET Analysis</strong> tools. 
            This chapter's data is currently being verified by our experts.
          </p>
          
          <div className="cs-loader">
            <div className="cs-progress"></div>
          </div>

          <Link to="/" className="home-btn">
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;